import React from "react";

export function DetailFieldQuantityComponent ({presentedShift, bulkQuantity, handleQuantityChange}) {

    const validateQuantityChange = (e) => {
        console.log(e);
        const value = e.target.value;
        const isValid = /^\d+$/.test(value); // Check if the value is a valid number
        if (!isValid) {
            e.preventDefault();
            e.target.value = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
            return;
        }

        if( value>9999 ){
            e.preventDefault();
            e.target.value = value.slice(0,-1);
            return;
        }

        handleQuantityChange(e);
    }

    return (
        <div className={ 'quantity-wrap '}>
            <div className="title-label">Quantity</div>
            <input className='quantity-input' onChange={validateQuantityChange} defaultValue={ presentedShift?.name == 'open_shift' ? presentedShift?.total_shifts_available : bulkQuantity}/>
        </div>
    )
}

export default DetailFieldQuantityComponent; 